import React from "react";
import { ReactElement } from "react";

export default function LoadingScreen(): ReactElement {
  return (
    <div className="w-100 bg-black d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
      <div className="col-6 col-md-5 col-lg-4 col-xl-3 col-xxl-2">
        <img src="/assets/logo-niks-production.png" alt="Logo Niks Production" className="w-100"/>
      </div>
    </div>
  );
}